'use client';

import { AppToaster as SharedAppToaster } from '@ui/components/toast/AppToaster';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

export function AppToaster() {
  const t = useTranslations('common');

  const toastHeaders = useMemo(
    () => ({
      error: t('toastError'),
      warning: t('toastWarning'),
      success: t('toastSuccess'),
    }),
    [t]
  );

  return <SharedAppToaster variantHeaders={toastHeaders} />;
}
